module.exports = __webpack_public_path__ + "img/violet_128.5264ac3a.png";